<template>
  <div class="editbox">
    <infoSlider :style="{zIndex: 999}" :show="add"
    @close="getMember=false;getAgency=false;$emit('close')"
    :label="label||'新增預約'" defaultClass="123" :width="481" :icon="'calendar'">
      <div class="editCube" v-if="add">
        <section class="top orders" :label="storeType==='shop'?'預購商品':'預約品項'">
            <div>
              <OrderCardEdit v-for="(order, o) in editItem.Orders" :key="order._id" :item="order" @update="editItem.Orders.splice(o, 1, $event)" @delete="editItem.Orders.splice(o, 1)"/>
              <hr class="hr2">
              <RBtn :text="'新增品項'" :icon="'add'" :bg="'var(--color-checked)'" :style="{marginInline: 'auto', marginBlock: '30px'}" @click="addorders=true"/>
              <hr class="hr2">
            </div>
        </section>
        <section class="top" label="備註">
            <textarea v-model="editItem.remark"></textarea>
        </section>
        <section class="top" label="備註(廚房)">
            <textarea v-model="editItem.remarkKitchen"></textarea>
        </section>
        <section class="top" label="業務經辦(員工)">
            <div :style="{paddingRight: '28px', gap: '20px', display: 'flex', flexDirection: 'column'}">
              <div class="field field-edit" :style="{gridTemplateColumns: '90px 1fr'}">
                <div :style="{width:'60px', whiteSpace:'nowrap'}">業務來源</div>
                <Select1 :style="{width: '100%'}" :defaultValue="editItem.source" @input="editItem.source=$event">
                  <option :value="null">請選擇業務來源</option>
                  <option v-for="(sour, s) in source" :key="`sour-${s}`" :value="sour.key">{{sour.key}}</option>
                </Select1>
              </div>
              <div class="field field-edit" :style="{gridTemplateColumns: '90px 1fr'}">
                <div :style="{width:'60px', whiteSpace:'nowrap'}">經辦人員</div>
                <Select1 :style="{width: '100%'}" :defaultValue="editItem.salesman" @input="editItem.salesman=$event">
                  <option :value="null">請選擇經辦人員</option>
                  <option v-for="(sman, i) in salesmans" :key="`sman-${i}`" :value="sman._id">
                {{sman.department}} | {{sman.post}} | {{sman.name}}</option>
                </Select1>
              </div>
            </div>
        </section>
        <section :style="{order:-6}">
            <div class="field field-edit">
              <div>預約狀態</div>
              <Select1 :width="'180px'" :defaultValue="editItem.status" @input="editItem.status=$event">
                <option v-for="(stat, i) in statuslist" :key="`stat-${i}`" :value="stat">{{stat}}</option>
              </Select1>
            </div>
            <div class="field field-edit">
              <div>預約類型</div>
              <div class="orderTypes">
                <input type="radio" v-for="(stat, i) in types" :key="`stat-${i}`" :class="stat" :value="stat" v-model="editItem.type">
              </div>
            </div>
            <div class="field field-edit" :style="{zIndex: 9}">
              <div>{{storeType==='shop'?'取貨':'預約'}}日期</div>
              <div><DateInput :style="{width: '230px', margin:0}" :defaultValue="editItem.visitDate" @input="editItem.visitDate=$event"/></div>
            </div>
            <div class="field field-edit" :style="{zIndex: 8}">
              <div>{{storeType==='shop'?'取貨':'預約'}}時段</div>
              <div><TimeInput :style="{width: '230px', margin:0}" :defaultValue="editItem.visitTime" @input="editItem.visitTime=$event"/></div>
            </div>
            <div class="field field-edit">
              <div>VIP</div>
              <div :style="{gap: '20px', display: 'flex', alignItems: 'center', justifyContent: 'flex-start'}">
                <input type="radio" class="vip" v-model="editItem.level" :value="1">
                <input type="radio" class="vvip" v-model="editItem.level" :value="2">
                <input type="radio" class="supervip" v-model="editItem.level" :value="3">
                <input type="radio" class="none" v-model="editItem.level" :value="0">
              </div>
            </div>
            <div class="field field-edit">
              <div>專案名稱</div>
              <label for="project-input">
                <input type="text" list="project" id="project-input" v-model="editItem.project">
                <datalist id="project"><option v-for="(pj, j) in projects" :key="j" :value="pj"></option></datalist>
              </label>
            </div>
            <div class="field field-edit">
              <div>{{storeType==='shop'?'訂購':'預約'}}人</div>
              <input type="text" v-model="editItem.orderer">
            </div>
            <div class="field field-edit">
              <div>聯絡電話</div>
              <input type="text" v-model="editItem.ordererTel">
            </div>
            <template v-if="storeType==='shop'">
            <div class="field field-edit">
              <div>取貨人</div>
              <input type="text" v-model="editItem.recipient">
            </div>
            <div class="field field-edit">
              <div>聯絡電話</div>
              <input type="text" v-model="editItem.recipientTel">
            </div>
            </template>
            <template v-if="storeType==='event'">
            <div class="field field-edit" v-if="field2">
              <div>{{field2}}</div>
              <input type="text" v-model="editItem.recipient">
            </div>
            <div class="field field-edit" v-if="field3">
              <div>{{field3}}</div>
              <input type="text" v-model="editItem.recipientTel">
            </div>
            </template>
            <template v-else-if="storeType==='tickets'">
            <div class="field field-edit">
              <div>領隊</div>
              <input type="text" v-model="editItem.recipient">
            </div>
            <div class="field field-edit">
              <div>聯絡電話</div>
              <input type="text" v-model="editItem.recipientTel">
            </div>
            <div class="field field-edit">
              <div>團體名稱</div>
              <input type="text" v-model="editItem.groupName">
            </div>
            <div class="field field-edit">
              <div>團體類別</div>
              <input type="text" v-model="editItem.teamAttributes">
            </div>
            <div class="field field-edit">
              <div>地區</div>
              <Select1 :defaultValue="editItem.area" @input="editItem.area=$event">
                <option :value="null">地區</option>
                <option v-for="(country, c) in countries" :key="`countries-${c}`" :value="country">{{country}}</option>
              </Select1>
            </div>
            </template>
            <template v-if="editItem.type==='宅配'">
            <div class="field">
              <div>宅配地址</div>
              <textarea v-model="editItem.address" :style="{minHeight: '120px'}"></textarea>
            </div>
            </template>
            <div class="field field-edit" :style="{zIndex: 6}">
              <div>會員編號</div>
              <div class="flexrow" :style="{gap: '8px'}">
                <div class="inputtext" :style="{width: '-webkit-fill-available', border: '1px solid #CACACA', height: '40px', borderRadius: '3px'}">
                  {{editItem.member?.memberID||editItem.memberID}}
                </div>
                <Sqr40016w :icon="'book'" :bg="'var(--color-pri)'" @click="getMember=!getMember"></Sqr40016w>
              </div>
            </div>
            <div class="field field-edit" :style="{zIndex: 6}" v-if="editItem.member">
              <div>會員姓名</div>
              <div>{{editItem.member?.name||editItem.memberID}}</div>
            </div>
            <div class="field field-edit" :style="{zIndex: 7}">
              <div>旅行社</div>
              <div class="flexrow" :style="{gap: '8px'}">
                <div class="inputtext" :style="{width: '-webkit-fill-available', border: '1px solid #CACACA', height: '40px', borderRadius: '3px'}">
                  {{editItem.agency?.name||editItem.agencyName}}
                </div>
                <Sqr40016w :icon="'book'" :bg="'var(--color-pri)'" @click="getAgency=!getAgency"></Sqr40016w>
              </div>
            </div>
            <div class="field field-edit"  v-if="storeType!=='shop'">
              <div>預約人數</div>
              <div :style="{justifyContent: 'space-between', display: 'flex'}">
                <input type="text" v-model="editItem.reserveNum" :style="{width: '80px', textAlign: 'center'}">大
                <input type="text" v-model="editItem.reserveNumChild" :style="{width: '80px', textAlign: 'center'}">小
              </div>
            </div>
        </section>
        <BtnsS :style="{marginTop: '15px'}" @cancel="$emit('close')" @save="save"/>
      </div>
    </infoSlider>
      <agSelector v-if="add" :show="getAgency" :items="agencyText?[{taxID: agencyText, name: agencyText}, ...agenciesShort] : agenciesShort" @search="agencyText=$event" :search="agencyText">
        <div slot-scope="{item}" @click="editItem.agency=JSON.parse(JSON.stringify(item));getAgency=false">
          <div>{{item.name}}</div>
        </div>
      </agSelector>
      <agSelector v-if="add" :show="getMember" :items="members" @search="memberText=$event" :search="memberText">
        <div slot-scope="{item}" @click="editItem.member=JSON.parse(JSON.stringify(item));getMember=false" :style="{gap: '20px'}">
          <div>{{item.mobile || '------------'}}</div> <div>{{item.name}}</div>
        </div>
      </agSelector>
    <AddOrders v-if="add&&addorders" @close="addorders=false" :products="products" @add="addorder" :agencyID="editItem.member?.verified&&editItem.member.role==='shop'&&editItem.member?.agencyID "/>
  </div>
</template>

<script>

import agSelector from './agencySelector.vue'
import RBtn from '../../components/btn/round.vue'
import AddOrders from './AddOrders.vue'
import DateInput from '../../components/input/date.vue'
import TimeInput from '../../components/input/time.vue'
import OrderCardEdit from './orderCardEdit.vue'
import infoSlider from '../../components/infoSlider_v2.vue'
import { putapi, getapi } from '../../store/fetch'
import Sqr40016w from '../../components/btn/sqr30016wb.vue'
import { mapState } from 'vuex'
export default {
  props: ['refdata', 'add', 'salesmans', 'projects', 'statuslist', 'products', 'store', 'types', 'storeType', 'field2', 'field3', 'source', 'label'],
  components: {
    agSelector,
    RBtn,
    infoSlider,
    OrderCardEdit,
    DateInput,
    TimeInput,
    AddOrders,
    Sqr40016w
  },
  data () {
    return {
      getAgency: false,
      getMember: false,
      addorders: false,
      edit: null,
      editItem: {
        address: null,
        type: '自取',
        status: '新訂單',
        visitDate: this.moment().format('yyyy-MM-DD'),
        visitTime: this.moment().format('HH:mm'),
        orderer: null,
        ordererTel: null,
        recipient: null,
        recipientTel: null,
        level: null,
        project: null,
        reserveNum: 1,
        reserveNumChild: 0,
        agency: {
          taxID: null,
          name: null
        },
        member: null,
        Orders: [],
        remark: null,
        remarkKitchen: null,
        salesman: null,
        source: '自來電'
      },
      memberText: null,
      members: [],
      agencyText: null,
      agenciesShort: []
    }
  },
  watch: {
    agencyText () {
      this.getagenciesShort()
    },
    getAgency () {
      if (this.getAgency) {
        this.getMember = false
        this.getagenciesShort()
      }
    },
    getMember () {
      if (this.getMember) {
        this.getAgency = false
        this.getMembers()
      }
    },
    memberText () {
      this.getMembers()
    },
    add () {
      this.addorders = false
      this.memberText = null
      this.agencyText = null
      this.editItem = {
        address: null,
        type: this.storeType === 'restaurant' ? '內用' : '自取',
        status: this.storeType === 'restaurant' ? '預約中' : '新訂單',
        visitDate: this.moment().format('yyyy-MM-DD'),
        visitTime: this.moment().format('HH:mm'),
        orderer: null,
        ordererTel: null,
        level: null,
        project: null,
        reserveNum: 1,
        reserveNumChild: 0,
        agency: {
          taxID: null,
          name: null
        },
        member: null,
        Orders: [],
        remark: null,
        remarkKitchen: null,
        salesman: null,
        source: '自來電'
      }
      console.log(this.refdata, 'refdata', !!this.refdata)
      if (this.refdata) {
        const data = JSON.parse(JSON.stringify(this.refdata))
        const { orderer, ordererTel, agency, source, salesman, reserveNum, visitDate, visitTime } = data
        this.editItem.visitDate = this.moment(visitDate).utcOffset(+8).startOf('day').format('yyyy-MM-DD')
        this.editItem.visitTime = visitTime
        this.editItem.orderer = orderer
        this.editItem.ordererTel = ordererTel
        this.editItem.agency = agency
        this.editItem.source = source || '自來電'
        this.editItem.salesman = salesman?._id || null
        this.editItem.reserveNum = reserveNum
      }
      if (this.storeType === 'shop') {
        this.editItem.recipient = null
        this.editItem.recipientTel = null
      }
    }
  },
  computed: {
    member () {
      return this.item && (this.item.member || this.item.ordererID)
    },
    ...mapState({
      countries: 'countries'
    })
  },
  methods: {
    clearmember () {
      console.log('remove btn clicked', this.editItem.member)
      this.editItem.member = null
      console.log('remove btn clicked  --- end', this.editItem.member)
    },
    addorder (ev) {
      console.log(ev)
      console.table([...[].concat(...this.editItem.Orders.map(e => e.items)), ...ev.items])
      this.editItem.Orders.push(ev)
    },
    async getMembers () {
      if (this.memberText || this.getMember) {
        const params = {}
        if (this.memberText) {
          params.Search = this.memberText
        }
        this.members = await getapi('users/recent?' + new URLSearchParams(params))
      } else {
        this.members = []
      }
    },
    async getagenciesShort () {
      if (this.agencyText || this.getAgency) {
        const params = {}
        if (this.agencyText) {
          params.search = this.agencyText
        }
        this.agenciesShort = await getapi(`agencies/short?${new URLSearchParams(params)}`)
      } else {
        this.agenciesShort = []
      }
    },
    async save () {
      const params = { ...this.editItem, store: this.store }
      if (params.agency?.taxID) {
        params.agencyID = params.agency?.taxID
      }
      params.Orders = params.Orders.map(e => {
        const couponsSend = e.coupons ? JSON.parse(JSON.stringify(e.coupons)) : []
        delete e.coupons
        return { ...e, couponsSend }
      })
      if (params.Orders.filter(e => /導覽/ig.test(e.name)).length > 0) params.guideNeed = true
      params.visitDate = this.moment(params.visitDate).startOf('day').toISOString()
      const ret = await putapi('restaurant', params)
      if (ret) {
        this.$emit('updateItem', ret)
        if (this.refdata) {
          this.$router.push({ name: ret.store === '松柏軒' ? 'restaurantViewH' : 'restaurantView', query: { page: ret.store, start: this.moment(ret.visitDate).format('yyyy-MM-DD') } })
        }
      }
    }
  }
}
</script>
<style lang="scss">
.editbtn1 {
  &.absbtn {
    width: 32px;
    height: 32px;
    &::before {
      background-color: var(--color-pri);
    }
  }
}
</style>
<style lang="scss" scoped>
*, *::before, *::after {
  box-sizing: border-box;
}
.orderTypes {
  display: flex;
  align-items: center;
  gap: 10px;
}
.orderTypes > input {
  appearance: none;
  width: fit-content;
  height: 39px;
  background: #FFFFFF;
  border: 1.5px solid;
  border-radius: 20px;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  letter-spacing: 0.1em;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  &::before {
    content: attr(value);
  }
  &.男 {
    border: 1.5px solid var(--男);
    color:  var(--男);
    &:checked {
      background-color: var(--男);
    }
  }
  &.女 {
    border: 1.5px solid var(--女);
    color:  var(--女);
    &:checked {
      background-color: var(--女);
    }
  }
  &.戶外證婚 {
    border: 1.5px solid var(--戶外證婚);
    color:  var(--戶外證婚);
    &:checked {
      background-color: var(--戶外證婚);
    }
  }
  &.婚紗攝影 {
    border: 1.5px solid var(--婚紗攝影);
    color:  var(--婚紗攝影);
    &:checked {
      background-color: var(--婚紗攝影);
    }
  }
  &.內用 {
    border: 1.5px solid var(--內用);
    color:  var(--內用);
    &:checked {
      background-color: var(--內用);
    }
  }
  &.內用 {
    border: 1.5px solid var(--內用);
    color:  var(--內用);
    &:checked {
      background-color: var(--內用);
    }
  }
  &.外帶 {
    border: 1.5px solid var(--外帶);
    color:  var(--外帶);
    &:checked {
      background-color: var(--外帶);
    }
  }
  &.自取 {
    border: 1.5px solid var(--自取);
    color:  var(--自取);
    &:checked {
      background-color: var(--自取);
    }
  }
  &.宅配 {
    border: 1.5px solid var(--宅配);
    color:  var(--宅配);
    &:checked {
      background-color: var(--宅配);
    }
  }
  &.現場 {
    border: 1.5px solid var(--現場);
    color:  var(--現場);
    &:checked {
      background-color: var(--現場);
    }
  }
  &.線上 {
    border: 1.5px solid var(--線上);
    color:  var(--線上);
    &:checked {
      background-color: var(--線上);
    }
  }
  &:checked {
    color: #FFFFFF;
  }
}
input.vip, input.vvip, input.supervip, .none {
  width: 30px;
  height: 30px;
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: contain;
  appearance: none;
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;
  background-color: transparent;
  filter: contrast(.5);
  &:checked {
    filter: contrast(1);
  }
}
input.vip {
  background-image: url(/vip.svg);
}
input.vvip {
  background-image: url(/vvip.svg);
}
input.supervip {
  background-image: url(/supervip.svg);
}

.none {
  background-color: #cacaca;
  mask-image: url(/svg/btn/close.svg);
  mask-size: 20px;
  filter: contrast(1);
  &:checked {
    background-color: transparent;
  }
}
.hr2 {
  margin: .5em 0;
  border-block: 3px solid #FFFFFF;
  border-inline: 8px solid var(--color-pri);
  background-color: var(--color-pri);
  height: 8px;
}
.editbox {
  position: fixed;
  left: auto;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 10;
}
label {
  position: relative;
  z-index: 1;
}
.removebtn {
  margin-left: auto;
}
.absbtn {
  position: absolute;
  top: 20px;
  right: 18px;
}
.agency-box {
  display: flex;
  align-items: center;
  height: 40px;
  padding-inline: .75em;
  border: 1px solid #CACACA;
  border-radius: 3px;
  font-size: 18px;
  button {
    background-color: #CACACA;
    width: 23px;
    height: 30px;
    mask-image: url(/svg/btn/close.svg);
    mask-size: 15px;
    mask-repeat: no-repeat;
    mask-position: center;
    border: none;
    outline: 1px solid #CACACA;
    box-sizing: content-box;
    padding: 0;

  }
}
.internalremark {
  display: flex;
  flex-direction: column;
  gap: 6px;
  &>:nth-child(1) {
    font-weight: 400;
    font-size: 16px;
    line-height: 180%;
    color: #FFFFFF;
    width: 125px;
    height: 30px;
    background: #FF7373;
    border-radius: 50px;
  }
  &>:nth-child(2) {
    text-align: start;
    font-weight: 400;
    font-size: 15px;
    line-height: 180%;
    color: #FF7373;
  }
}
.field-foot {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  font-weight: 400;
  font-size: 16px;
  line-height: 23px;
  color: #999999;
  letter-spacing: 0;
}
hr {
  height: 1px;
  border: none;
  background-color:#CACACA;
  width: 100%;
  margin: 0;
}
.flexrow {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.field {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: 90px 1fr;
  gap: 28px;
  &.field-edit {
    line-height: 35px;
    position: relative;
  }
  &>:nth-child(1) {
    text-align: end;
    position: relative;
    z-index: 1;
  }
  label {
    position: relative;
    z-index: 1;
  }
  input[type=text], textarea, .inputtext {
    position: relative;
    z-index: 1;
    width: 220px;
    height: 40px;
    border: 1px solid #CACACA;
    border-radius: 3px;
    padding-inline: .75em;
    box-sizing: border-box;
    font-size: 18px;
    color: #5E5E5E;
  }
  .inputtext {
    white-space: nowrap;
    overflowX: auto;
    display: flex;
    text-align: start;
    align-items: center;
    max-width: 220px;
  }
  textarea {
    padding-block: .5em;
  }
  &>:nth-child(2) {
    text-align: start;
    z-index: 1;
    position: relative;
    * {
      position: relative;
      z-index: 1;
    }
    .ul {
      position: absolute;
      right: 0;
      width: 350px;
      background-color: #FFFFFF;
      max-height: 230px;
      overflow-y: auto;
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
      z-index: 99;
      .li {
        z-index: 99;
        position: relative;
        padding-block: 7.25px;
        padding-inline: .75em;
        min-height: 55px;
        display: flex;
        align-items: flex-start;
        gap: 10px;
        line-height: 40px;
        &:hover {
          background-color: #CACACA;
        }
      }
    }
  }
}
section {
  position: relative;
  z-index: 1;
  flex: 1;
  border: 1px solid #B9B9B9;
  border-radius: 10px;
  padding: 20px 20px 13px 23px;
  width: 100%;
  font-weight: 400;
  font-size: 20px;
  line-height: 29px;
  letter-spacing: 0.1em;
  color: #5E5E5E;
  display: flex;
  flex-direction: column;
  gap: 11px;
  height: fit-content;
}
section.top {
  padding: 0;
  z-index: 1;
  flex: 1;
  &::before {
    content: attr(label);
    display: inline;
    width: 100%;
    height: 45px;
    background-color: var(--color-pri);
    color: #FFFFFF;
    text-align: start;
    border-radius: 10px 10px 0 0;
    display: flex;
    align-items: center;
    padding-inline: 28px;
  }
  &>div, &>textarea{
    border: none;
    height: fit-content;
    padding: 21px 13px 21px 28px;
    text-align: start;
    font-weight: 400;
    font-size: 20px;
    line-height: 29px;
    letter-spacing: 0.1em;
    color: #787878;
  }
  textarea {
    min-height: 200px;
  }
}
section.orders>div:nth-child(1) {
  gap: 15px;
  display: flex;
  flex-direction: column;
}
.editCube {
  flex: 1;
  padding: 31px 20px 30px 30px;
  display: grid;
  grid-template-columns: 1fr;
  width: 100%;
  margin-right: 8px;
  height: 100%;
  overflow-y: auto;
  align-content: flex-start;
  gap: 19px;
}
</style>
